import { FunctionComponent } from 'react';
import clsx from 'clsx';

const CardTitle: FunctionComponent<{ textCenter?: boolean }> = ({
  textCenter,
  children,
}) => {
  return (
    <p className={clsx('fs-20 text-dark', { 'text-center': textCenter })}>
      {children}
    </p>
  );
};
export default CardTitle;
